// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsvideoconfig = {
    awsInputVideo: 'elpisvideo8-staging-input-38pu85n6',
    awsOutputVideo: 'elpisvideo8-staging-output-38pu85n6.s3.us-west-2.amazonaws.com',
};
export default awsvideoconfig;
